import { formatAmount } from "../utils/Utils";

export enum BulkTypes {
    special = 'special',
    group = 'group',
    event = 'event',
    city = 'city',
    distanceFromMyself = 'distanceFromMyself',
}

export interface BulkPaymentData {
    id: string;
    type: BulkTypes;
    name: string;
    recipientsCount: number;
    maxSendablePerRecipient?: number;
}

export class BulkPayment {
    type: BulkTypes;
    id: string;
    name: string;
    recipientsCount: number;
    maxSendablePerRecipient?: number;

    constructor(data: BulkPaymentData) {
      this.type = data.type;
      this.id = data.id;
      this.name = data.name;
      this.recipientsCount = data.recipientsCount;
      this.maxSendablePerRecipient = data?.maxSendablePerRecipient ?? undefined;
    }

    getDisplayName(): string {
        if(this.recipientsCount > 0) {
            return `${this.name} (${formatAmount(this.recipientsCount)})`;
        }
        else {
            return this.name;
        }
    }

    toJson(): BulkPaymentData {
        return {
            id: this.id,
            type: this.type,
            name: this.name,
            recipientsCount: this.recipientsCount,
            maxSendablePerRecipient: this.maxSendablePerRecipient
        }
    }
}